import React from 'react'
import { Project } from 'src/core/models'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { Gallery } from '@climatetradecarbon/climatetrade-components'
import ProjectDetailsCollapse from '../ProjectDetailsCollapse/ProjectDetailsCollapse'

const ProjectDetailsGallery: React.FC<{ project: Project }> = ({ project }) => {
  const { t } = useTranslation()

  const getImages = (): string[] => {
    let projectImages: string[] = []
    if (!project.main_image && project.cover) { projectImages.push(project.cover )}
    if (project.main_image) projectImages.push(project.main_image)
    project.pictures?.forEach(picture => projectImages.push(picture?.image))
    return projectImages
  }

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.Gallery')} strong/>}>
      <Gallery limit={4} images={getImages()} objectFit='cover' />
    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsGallery
